import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';


function PageTitle({ translationKey }) {
  const { t } = useTranslation();

  return (
    <Typography
      variant="h4"
      component="h1"
      gutterBottom
      sx={{
        textAlign: 'center',
        color: '#2c3e50',
        fontSize: '2rem',
        margin: '1.5rem 0',
        letterSpacing: '1px',
        textTransform: 'uppercase',
      }}
    >
      {t(translationKey)}
    </Typography>
  );
}

export default PageTitle;